import { render } from "./Investment_type.vue?vue&type=template&id=00440124&scoped=true"
import script from "./Investment_type.vue?vue&type=script&lang=js"
export * from "./Investment_type.vue?vue&type=script&lang=js"

import "./Investment_type.vue?vue&type=style&index=0&id=00440124&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00440124"]])

export default __exports__